import { useCallback, useEffect, useMemo, useState } from 'react';

export type PaginationResponse<T = any> = {
  data: T[];
  next_cursor: string | null;
  next_page_url: string | null;
  path: string;
  per_page: number;
  prev_page_url: string | null;
  previous_cursor: string | null;
};

export default function usePagination<T>() {
  const [response, setResponse] = useState<PaginationResponse<T>>();
  const [cursor, setCursor] = useState<string>();

  useEffect(() => {
    if (response === undefined) {
      setCursor(undefined);
    }
  }, [response]);

  const loadMore = useCallback(() => {
    if (response && response.next_cursor) {
      setCursor(response.next_cursor);
    }
  }, [response]);

  const hasMore = useMemo(
    () => response !== undefined && response.next_cursor !== null,
    [response]
  );

  return { cursor, loadMore, hasMore, setResponse };
}
